'use client';

import { useEffect, useRef } from 'react';
import { CHARTBEAT_CONFIG_SCRIPT_ID, generateChartbeatConfig } from '@benzinga/analytics';

interface ChartbeatAnalyticsProps {
  authorName: string;
  onConfigApplied?: () => void;
  sections: string[];
  useCanonical?: boolean;
}

export const ChartbeatAnalytics: React.FC<ChartbeatAnalyticsProps> = ({
  authorName,
  onConfigApplied,
  sections,
  useCanonical = false,
}) => {
  const onConfigAppliedRef = useRef(onConfigApplied);
  onConfigAppliedRef.current = onConfigApplied;

  useEffect(() => {
    const sectionsValue = sections.join(', ');

    if (window.chartbeatLoaded && window.pSUPERFLY) {
      if (window._sf_async_config) {
        window._sf_async_config.authors = authorName;
        window._sf_async_config.sections = sectionsValue;
      }

      window.pSUPERFLY.virtualPage({
        authors: authorName,
        path: window.location.pathname,
        sections: sectionsValue,
        title: document.title,
      });
      onConfigAppliedRef.current?.();
      return;
    }

    const chartbeatConfig = generateChartbeatConfig({
      authorName,
      chartBeatDomain: 'benzinga.com',
      sections,
      uid: process.env.CHARTBEAT_KEY as string,
      useCanonical,
    });

    document.getElementById(CHARTBEAT_CONFIG_SCRIPT_ID)?.remove();
    const script = document.createElement('script');
    script.id = CHARTBEAT_CONFIG_SCRIPT_ID;
    script.text = chartbeatConfig;
    document.head.appendChild(script);
    onConfigAppliedRef.current?.();
  }, [authorName, sections, useCanonical]);

  return (
    <>
      <link as="script" href="https://static.chartbeat.com/js/chartbeat.js" rel="preload" />
      <script async src="https://static.chartbeat.com/js/chartbeat_mab.js" />
    </>
  );
};
